export const getStoredTheme = (): boolean => {
  if (typeof window === 'undefined') return true;
  const stored = window.localStorage.getItem('studyAbroadDarkMode');
  if (stored === null) return true;
  return stored === 'true';
};

export const applyTheme = (dark: boolean) => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (dark) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('studyAbroadDarkMode', dark ? 'true' : 'false');
  }
};

export const initTheme = (): boolean => {
  const dark = getStoredTheme();
  applyTheme(dark);
  return dark;
};
